import { Breadcrumb, Layout, Spin, Form, Input, DatePicker, Button, Row, Col, Card, Switch, message, Select } from 'antd';
import { Content } from 'antd/es/layout/layout';
import Headerdiv from '../layout/header';
import Footerdiv from '../layout/footer';
import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axiosClient from '../../api/axiosClient';
import { APPBACKGROUND_COLOR } from '../appsettings';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const { TextArea } = Input;

const AddInventory = () => {
    const [form] = Form.useForm();
    const USERID = localStorage.getItem("USERID");
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [types, setTypes] = useState([]);
    const navigate = useNavigate();


    const fetchCategories = async () => {
        try {
            const response = await axiosClient.get('/master/category/get_all_categories_dropdown.php');
            const result = response.data;

            if (result.status === 'success') {
                setCategories(result.data);
            } else {
                message.error(result.message || 'Failed to fetch categories.');
            }
        } catch (error) {
            console.error('Fetch categories error:', error);
            message.error(error.response?.data?.message || 'Network error.');
        }
    };

    const fetchTypes = async () => {
        try {
            const response = await axiosClient.get('/master/type/get_all_types_dropdown.php');
            const result = response.data;

            if (result.status === 'success') {
                setTypes(result.data);
            } else {
                message.error(result.message || 'Failed to fetch types.');
            }
        } catch (error) {
            console.error('Fetch types error:', error);
            message.error(error.response?.data?.message || 'Network error.');
        }
    };

    useEffect(() => {
        Promise.all([fetchCategories(), fetchTypes()]);
    }, []);

    const onFinish = async (values) => {
        setLoading(true);
        const payload = {
            ...values,
            register_date: values.register_date ? values.register_date.format("YYYY-MM-DD") : null,
            eol_date: values.eol_date ? values.eol_date.format("YYYY-MM-DD") : null,
            status: values.status ? true : false,
            by: USERID
        };

        try {
            const response = await axiosClient.post('/inventory/add_to_inventory.php', payload);
            const data = response.data;

            if (data.status === "success") {
                message.success(data.message);
                form.resetFields();
                navigate('/inventory/itemList');
            } else {
                message.error(data.message || "Failed to add item.");
            }
        } catch (error) {
            console.error("API Error:", error);
            message.error(error.response?.data?.message || "Failed to connect to server.");
        } finally {
            setLoading(false);
        }
    };



    return (
        <Spin spinning={loading} tip="Saving Item...">
            <Layout style={{ backgroundColor: APPBACKGROUND_COLOR, minHeight: '100vh' }}>
                <Headerdiv />
                <Content style={{ padding: "10px" }}>
                    <Breadcrumb style={{ marginBottom: 10 }}>
                        <Breadcrumb.Item><Link to={"/inventory/itemList"}>Inventory</Link></Breadcrumb.Item>
                        <Breadcrumb.Item>Add Item</Breadcrumb.Item>
                    </Breadcrumb>

                    <Form layout="vertical" form={form} onFinish={onFinish}>
                        <Card title="Item Information">
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="item_code"
                                        label="Item Code"
                                        rules={[{ required: true, message: "Item Code is required" }]}
                                    >
                                        <Input placeholder="Enter Item Code" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="name"
                                        label="Item Name"
                                        rules={[{ required: true, message: "Item Name is required" }]}
                                    >
                                        <Input placeholder="Enter Item Name" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="type"
                                        label="Type"
                                        rules={[{ required: true, message: "Type is required" }]}
                                    >
                                        <Select placeholder="Select Type">
                                            {types.map((type) => (
                                                <Select.Option key={type.id} value={type.value}>
                                                    {type.value}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="category"
                                        label="Category"
                                        rules={[{ required: true, message: "Category is required" }]}
                                    >
                                        <Select placeholder="Select Category">
                                            {categories.map((category) => (
                                                <Select.Option key={category.id} value={category.value}>
                                                    {category.value}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="register_date"
                                        label="Register Date"
                                        rules={[{ required: true, message: "Register Date is required" }]}
                                    >
                                        <DatePicker style={{ width: "100%" }} />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="eol_date"
                                        label="End of Life Date"
                                        rules={[{ required: true, message: "EOL Date is required" }]}
                                    >
                                        <DatePicker style={{ width: "100%" }} />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item name="status" label="Status" valuePropName="checked" initialValue={true}>
                                        <Switch />
                                    </Form.Item>
                                </Col>

                                <Col xs={24}>
                                    <Form.Item name="description" label="Description">
                                        <ReactQuill theme="snow" placeholder="Enter Description" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24}>
                                    <Form.Item name="note" label="Note">
                                        <TextArea rows={2} placeholder="Enter Note" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24}>
                                    <Row justify="end" gutter={[10, 10]} style={{ marginTop: 10 }}>
                                        <Col>
                                            <Button onClick={() => form.resetFields()}>Clear</Button>
                                        </Col>
                                        <Col>
                                            <Button type="primary" htmlType="submit">
                                                Save Item
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Card>
                    </Form>
                </Content>
                <Footerdiv />
            </Layout>
        </Spin>
    );
};

export default AddInventory;